module.exports = __webpack_public_path__ + "img/25_21.ffb869e4.png";